import React, { useEffect, useState } from "react";
import pic from "./data-not-found-png-yellow.jpg.png";
import pics from "./adoop-img.png";

export default function CategoryList() {
  const [data, setData] = useState([]);
  const [catalogData, setCatalogData] = useState([]);
  const [catalogParticularData, setCatalogParticularData] = useState([]);
  const [error, setError] = useState(null);

  const login = async () => {
    const requestBody = {
      username: "admin59adoop",
      password: "shop@OM89",
    };

    try {
      const response = await fetch(
        "https://api.adoop.in/api/auth/fetch_token?latitude=30.5656&longitude=70.0454",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      console.log("Login Response:", data);

      if (data?.token?.accessToken) {
        localStorage.setItem("accessToken", data.token.accessToken);
      } else {
        console.error("Login failed: Invalid response", data);
        throw new Error("Login failed: token not received");
      }
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  const fetchCatalogs = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const url = `https://api.adoop.in/api/v2/catalogs`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("Promotions:", data);
      setCatalogData(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    login();
    fetchCatalogs();
    fetchData();
  }, []);

  const fetchData = async (page = 1) => {
    const access_token = localStorage.getItem("accessToken");
    const url = `https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop?page=0&offset=100`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log("Promotions:", data.length);
      // setData(data);
      setCatalogParticularData(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

 const fetchParticularCatalogs = async (catalog, page = 1) => {
  const access_token = localStorage.getItem("accessToken");

  // Conditionally set the URL based on catalog name
  const url =
    catalog.name === "All"
      ? `https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop?page=${page}&offset=100`
      : `https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${catalog.id}?page=${page}&offset=100`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch promotions");
    }

    const data = await response.json();
    console.log("Promotions:", data);
    setCatalogParticularData(data);
  } catch (err) {
    console.error("Error fetching promotions:", err);
    setError(err.message);
  }
};


  const [orderedCatalogs, setOrderedCatalogs] = useState([]); // Reordered list

  // Initialize: first catalog is selected and list is ordered
  useEffect(() => {
    if (catalogData && catalogData.length > 0) {
      setData(catalogData[0]);
      setOrderedCatalogs(catalogData);
    }
  }, [catalogData]);

  const handleCatalogClick = async (catalog) => {
    setData(catalog);

    // Move selected catalog to the first position
    const newOrder = [
      catalog,
      ...orderedCatalogs.filter((c) => c.id !== catalog.id),
    ];
    setOrderedCatalogs(newOrder);

    // Fetch specific catalog data
    await fetchParticularCatalogs(catalog);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [shopkeepers, setShopkeepers] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken"); // Replace with actual token or load from context/localStorage

    if (searchTerm.length >= 2) {
      fetch(
        `https://api.adoop.in/api/v2/search_locations?search=${searchTerm}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ← Add this
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((data) => setCitySuggestions(data))
        .catch((err) => console.error("City fetch error:", err));
    } else {
      setCitySuggestions([]);
    }
  }, [searchTerm]);

  const [searchPerformed, setSearchPerformed] = useState(false);
  // Fetch shopkeepers based on filters
  const handleSearch = async () => {
    if (!selectedCity) return alert("Select a city");
    if (!data) return alert("Select a catalog");

    console.log("Selected City:", selectedCity);
    console.log("Search Term:", searchTerm);

    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(
        `https://api.adoop.in/api/v2/${selectedCity.id}/shop/${data.id}?page=0&offset=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (Array.isArray(result)) {
        setShopkeepers(result);
      } else {
        console.warn("Unexpected response format:", result);
        setShopkeepers([]);
      }

      setSearchPerformed(true); // 👈 Set flag to trigger UI update
    } catch (err) {
      console.error("Error fetching shopkeepers:", err);
      setShopkeepers([]);
      setSearchPerformed(true); // Still mark search done to show "no data"
    }
  };

  console.log("catalogParticularData :::" + catalogParticularData);

  return (
    <>
      <div className="container">
        <section style={{ paddingTop: "140px" }}>
          <div className="row">
            <div class="col-lg-6 col-md-6" style={{ display: "flex" }}>
              <h4 class="page-title">Catalog List</h4>
            </div>

            {/* Search Fields */}
            <div
              class="col-lg-6 col-md-6"
              style={{ display: "flex", justifyContent: "end" }}
            >
              {" "}
              <div style={{ marginBottom: "20px", position: "relative" }}>
                {/* City Search */}
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Enter city name"
                  style={{
                    padding: "8px 12px",
                    width: "400px",
                    border: "1px solid #ffc600",
                    boxShadow: "4px 4px 6px rgba(114, 114, 114, 0.2)",
                    borderRadius: "10px",
                  }}
                />
                {citySuggestions.length > 0 && (
                  <ul className="search-dropdown">
                    {citySuggestions.map((city) => (
                      <li
                        key={city.id}
                        onClick={() => {
                          setSelectedCity(city);
                          setSearchTerm(city.name);
                          setCitySuggestions([]);
                        }}
                        style={{
                          padding: "4px",
                          cursor: "pointer",
                          // borderBottom: "1px solid #eee",
                        }}
                      >
                        {city.name}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Search Button */}
                <button
                  onClick={handleSearch}
                  // style={{
                  //   padding: "4px 16px",
                  //   marginLeft: "10px",
                  //   background: "#ffffff",
                  //   border: "1px solid #ffc600",
                  //   borderRadius: "4px",
                  // }}
                  className="search-btn"
                >
                  <i class="bi bi-search"></i> Search
                </button>
              </div>
            </div>
          </div>

          {/* catalog list */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "0px",
              background: "#f9f9f9",
              borderRadius: "8px",
              padding: "10px",
              boxShadow: "rgb(215 215 215) 2px 2px 8px",
            }}
          >
            {catalogData.map((catalog) => (
              <div
                key={catalog.id}
                onClick={() => handleCatalogClick(catalog)}
                style={{
                  cursor: "pointer",
                  border:
                    data?.id === catalog.id ? "2px solid #FFC600" : "none",
                  padding: "8px",
                  borderRadius: "8px",
                  textAlign: "center",
                  width: "120px",
                  backgroundColor:
                    data?.id === catalog.id ? "#fffbea" : "transparent", // Optional: light yellow background
                }}
              >
                <img
                  src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${catalog.image}`}
                  alt={catalog.name}
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                />
                <p className="m-auto">{catalog.name}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* shopkeeper list */}

      <section>
        {catalogParticularData && (
          <div class="container rounded py-5">
            <div class="row">
              <h4> My Shopkeeper List <span class="badge bg-secondary mb-2" style={{ width: "40px" , height: "22px" , fontSize:"14px" , margin:"auto"}}> {catalogParticularData.length} </span> 
              </h4>
            </div>

            {searchPerformed ? (
              <div class="row">
                {Array.isArray(shopkeepers) && shopkeepers.length > 0 ? (
                  shopkeepers.map((promo) => (
                    <div class="col-sm-6">
                      <div class="card card-border-yellow shadow">
                        <div class="row g-0">
                          <div
                            className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                            style={{
                              height: "200px", // fixed height
                              overflow: "hidden",
                            }}
                          >
                            {/* <img
                            src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                              promo.logo || "default.jpg"
                            }`}
                            alt="No profile photo"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                          /> */}

                            <img
                              src={
                                promo.logo
                                  ? `https://d3p6cw3ny59ckg.cloudfront.net/store/${promo.logo}`
                                  : pics
                              }
                              alt="No profile photo"
                              style={{
                                // maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                            />

                            {!promo.logo && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  color: "white",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "100%",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                }}
                              >
                                No Image Available
                              </div>
                            )}
                          </div>

                          <div class="col-md-6">
                            <div class="card-body">
                              <h6
                                class="mb-3"
                                style={{
                                  fontWeight: "bold",
                                  textTransform: "capitalize",
                                }}
                              >
                                {promo.name || "No Name"}
                              </h6>
                              {/* <p class="card-text" style={{textTransform:"capitalize" }}>
                              {promo.description || "No Description"}
                            </p> */}
                              <p
                                className="mb-2"
                                style={{
                                  textTransform: "capitalize",
                                  //  fontSize:"10px"
                                }}
                              >
                                <strong>
                                  <i
                                    className="fas fa-map-marker-alt"
                                    style={{
                                      marginRight: "5px",
                                      color: "#ffc600",
                                    }}
                                  ></i>
                                </strong>{" "}
                                {promo.address || "N/A"}
                              </p>

                              {/* <p class="card-text">
                              <strong>
                                <i
                                  className="fas fa-phone-alt"
                                  style={{
                                    marginRight: "5px",
                                    color: "#ffc600",
                                  }} // or 'yellow'
                                ></i>
                              </strong>{" "}
                              {promo.user_info?.mobile || "No Mobile"}
                            </p> */}
                              {/* <p class="card"> */}
                              <p className="mb-2">
                                <strong>
                                  <i
                                    className="fas fa-city"
                                    style={{
                                      marginRight: "5px",
                                      color: "#ffc600",
                                    }} // or 'yellow'
                                  ></i>
                                </strong>{" "}
                                {promo.cityName || "No city"},{" "}
                                {promo.stateName || "No state"}
                              </p>

                              <p
                                class="mb-2"
                                style={{
                                  textTransform: "capitalize",
                                  maxHeight: "45px",
                                  overflowY: "auto",
                                }}
                              >
                                {promo.description || "No Description"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div class="col-12 text-center py-3">
                    <img src={pic} class="img-fluid rounded-start" alt="..." />
                    <h4>No data available.</h4>
                  </div>
                )}
              </div>
            ) : (
              <div class="row">
                {Array.isArray(catalogParticularData) &&
                catalogParticularData.length > 0 ? (
                  catalogParticularData.map((promo) => (
                    <div class="col-sm-6">
                      <div class="card card-border-yellow shadow">
                        <div class="row g-0">
                          <div
                            className="col-md-6 d-flex align-items-center justify-content-center border-right-home"
                            style={{
                              height: "200px", // fixed height
                              overflow: "hidden",
                            }}
                          >
                            {/* <img
                            src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${
                              promo.logo || "default.jpg"
                            }`}
                            alt="No profile photo"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                          /> */}

                            <img
                              src={
                                promo.logo
                                  ? `https://d3p6cw3ny59ckg.cloudfront.net/store/${promo.logo}`
                                  : pics
                              }
                              alt="No profile photo"
                              style={{
                                // maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                            />

                            {!promo.logo && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  color: "white",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "100%",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                }}
                              >
                                No Image Available
                              </div>
                            )}
                          </div>

                          <div class="col-md-6">
                            <div class="card-body">
                              <h6
                                class="mb-3"
                                style={{
                                  fontWeight: "bold",
                                  textTransform: "capitalize",
                                }}
                              >
                                {promo.name || "No Name"}
                              </h6>
                              {/* <p class="card-text" style={{textTransform:"capitalize" }}>
                              {promo.description || "No Description"}
                            </p> */}
                              <p
                                className="mb-2"
                                style={{
                                  textTransform: "capitalize",
                                  //  fontSize:"10px"
                                }}
                              >
                                <strong>
                                  <i
                                    className="fas fa-map-marker-alt"
                                    style={{
                                      marginRight: "5px",
                                      color: "#ffc600",
                                    }}
                                  ></i>
                                </strong>{" "}
                                {promo.address || "N/A"}
                              </p>

                              {/* <p class="card-text">
                              <strong>
                                <i
                                  className="fas fa-phone-alt"
                                  style={{
                                    marginRight: "5px",
                                    color: "#ffc600",
                                  }} // or 'yellow'
                                ></i>
                              </strong>{" "}
                              {promo.user_info?.mobile || "No Mobile"}
                            </p> */}
                              {/* <p class="card"> */}
                              <p className="mb-2">
                                <strong>
                                  <i
                                    className="fas fa-city"
                                    style={{
                                      marginRight: "5px",
                                      color: "#ffc600",
                                    }} // or 'yellow'
                                  ></i>
                                </strong>{" "}
                                {promo.cityName || "No city"},{" "}
                                {promo.stateName || "No state"}
                              </p>

                              <p
                                class="mb-2"
                                style={{
                                  textTransform: "capitalize",
                                  maxHeight: "45px",
                                  overflowY: "auto",
                                }}
                              >
                                {promo.description || "No Description"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div class="col-12 text-center py-3">
                    <img src={pic} class="img-fluid rounded-start" alt="..." />
                    <h4>No data available.</h4>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </section>
      {/* end of shopkeeper list */}
    </>
  );
}
